import { IonCheckbox, IonSpinner } from '@ionic/react'
import { SynerallInvoice } from '@vae/server/src/modules/ExternalAPIs/Synerall/synerallTypes'
import dayjs from 'dayjs'
import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useInvoices } from '../../../../hooks/useInvoices'
import { InvoiceExtensionFormFields } from '../InvoiceExtensionPage'

interface ChooseInvoiceStepProps {
	form: UseFormReturn<InvoiceExtensionFormFields>
}

const ChooseInvoiceStep: React.FC<ChooseInvoiceStepProps> = ({ form }) => {
	const { t } = useTranslation('pages_invoiceExtension')
	const { t: ti } = useTranslation('pages_invoices')

	const { isLoading, invoices } = useInvoices()

	const onInvoiceClick = (invoice: SynerallInvoice) => {
		if (form.getValues('invoiceId') === invoice.Number) {
			form.setValue('invoiceId', null)
			form.setValue('currentDueDate', '')
			form.setValue('newDueDate', '')
		} else {
			form.setValue('invoiceId', invoice.Number)
			form.setValue('currentDueDate', invoice.DueDate)
			form.setValue('newDueDate', invoice.DueDate)
		}
	}

	const isExtendable = (inv: SynerallInvoice) => {
		return dayjs(inv.DueDate).isAfter(dayjs()) && inv.Balance !== 0
	}

	const extendableInvoices = invoices?.unpaid.filter(isExtendable) ?? []

	if (isLoading || !invoices?.unpaid) {
		return <IonSpinner className='loader' name='crescent' />
	}

	return (
		<div id='invoices' style={{ paddingBottom: 0 }}>
			<div id='invoice-list'>
				{extendableInvoices.length === 0 && (
					<div className='due-date text-text-dark dark:text-white'>
						{t('chooseInvoiceStep.noAvailableInvoices')}
					</div>
				)}
				{extendableInvoices.map((invoice, i) => (
					<div key={i} onClick={() => onInvoiceClick(invoice)} className='invoice-card'>
						<div className='text-text-dark dark:text-white flex flex-row items-center pl-2 gap-4'>
							<IonCheckbox
								className='[--size:32px] mr-0 dark:[--border-color:#3cb49f] dark:[--border-color-checked:#3cb49f] dark:[--checkbox-background-checked:#3cb49f] dark:[--checkbox-background:#144448] [--border-color:#52ae32] [--border-color-checked:#52ae32] [--checkbox-background-checked:#52ae32] [--checkbox-background:#cae3cc]'
								checked={form.watch('invoiceId') === invoice?.Number}
							/>
							<div className='sum'>{invoice.Amount} €</div>
							<div className='flex flex-col'>
								<div className='due-date'>
									{`${ti('invoiceCard.erapaiva')}:`} {dayjs(invoice.DueDate).format('DD.MM.YYYY')}
								</div>
								<div className='due-date'>
									{'Viite:'} {invoice.PaymentReference}
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default ChooseInvoiceStep
